// extracted by mini-css-extract-plugin
export default {"Emoji":"bbk_a bhl_i bhl_q bhl_j"};